// eslint-disable-next-line no-unused-vars
import React, { useState } from 'react';

// eslint-disable-next-line no-unused-vars
const useForm = (callback) => {
  const [inputs, setInputs] = useState({});
  const [isSent, setIsSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = (event) => {
    if (event) {
      event.preventDefault();
    }
    setLoading(true);
    fetch('https://lawrence-price-web.herokuapp.com/api/v1/holding/contacts', {
      method: 'POST',
      body: JSON.stringify(inputs),
      headers: { 'Content-Type': 'application/json' },
    })
      .then((res) => res.json())
      .then(() => setLoading(false))
      .then(() => setIsSent(true));
  };
  const handleInputChange = (event) => {
    event.persist();
    // eslint-disable-next-line no-shadow
    setInputs((inputs) => ({ ...inputs, [event.target.name]: event.target.value }));
  };
  return {
    handleSubmit,
    handleInputChange,
    inputs,
    loading,
    isSent,
  };
};

export default useForm;
